export default class PhoneNumber {
  id: number;
  number: string;
  extension: string;
  phoneNumberType: PhoneType;

  constructor(
    id: number = null,
    number: string = "",
    extension: string = "",
    phoneType: string = ""
  ) {
    this.id = id;
    this.number = number;
    this.extension = extension;

    switch (phoneType.toUpperCase()) {
      case "HOME":
        this.phoneNumberType = PhoneType.HOME;
        break;
      case "MOBILE":
        this.phoneNumberType = PhoneType.MOBILE;
        break;
      case "FAX":
        this.phoneNumberType = PhoneType.FAX;
        break;
      default:
        this.phoneNumberType = PhoneType.HOME;
        break;
    }
  }
}

export enum PhoneType {
  HOME = 1,
  MOBILE = 2,
  FAX = 3,
}



// WEBPACK FOOTER //
// ./src/models/contact/phone-number.ts